/** 실제 제품 카드 — 배경 이미지 + 중앙 로고 */
function ProductCard({ variant, bg, bgAlt, logo, name, logoWidth, logoHeight }) {
  return (
    <div className={`product-card product-card-${variant}`}>
      <article className="card-slot">
        <img
          src={`/assets/images/${bg}`}
          alt={bgAlt}
          aria-hidden="true"
          width="220"
          height="360"
          className="bg-fill"
          loading="lazy"
        />
        <h3 className="card-center">
          <img
            src={`/assets/images/${logo}`}
            alt={name}
            width={logoWidth}
            height={logoHeight}
            className="card-logo"
            loading="lazy"
          />
        </h3>
      </article>
    </div>
  );
}

/** 3열 배경 장식 — 흐리게 깔려 읽히지 않으므로 장식 취급 */
function DecoCard({ variant, label }) {
  return (
    <div className={`product-card product-card-${variant}`}>
      <div className="card-slot">
        <p className="card-center card-deco-label">{label}</p>
      </div>
    </div>
  );
}

export function ProductLineupSection() {
  return (
    <section id="products" aria-labelledby="products-title" className="bg-surface-muted">
      <div className="inner product-stage relative overflow-hidden">
        {/* 좌측 카피 */}
        <h2
          id="products-title"
          className="heading-2 absolute top-1/2 left-20 z-10 -translate-y-1/2"
        >
          <img
            src="/assets/icons/nova-mark.svg"
            alt=""
            aria-hidden="true"
            width="24"
            height="24"
            className="section-mark"
            loading="lazy"
          />
          <span className="heading-line">플레인비트는</span>
          <span className="heading-line">다양한 산업과 규모에 맞춘</span>
          <span className="heading-line font-bold text-brand-600">솔루션과 서비스로</span>
          <span className="heading-line">침해사고 예방에 앞장섭니다.</span>
        </h2>

        {/* 카드 3열 (우측 정렬, 섹션 밖으로 넘치는 부분은 클리핑) */}
        <ul className="product-rail" role="list">
          <li className="product-col">
            <ProductCard
              variant="investigator"
              bg="card-investigator.png"
              bgAlt=""
              logo="logo-nova-investigator.png"
              name="Nova Investigator"
              logoWidth="188"
              logoHeight="49"
            />
          </li>

          <li className="product-col">
            <ProductCard
              variant="ai"
              bg="card-ai.png"
              bgAlt=""
              logo="logo-nova-ai-white.png"
              name="Nova AI"
              logoWidth="127"
              logoHeight="28"
            />
            <ProductCard
              variant="intelligence"
              bg="card-intelligence.jpg"
              bgAlt=""
              logo="logo-nova-intelligence.png"
              name="Nova Intelligence"
              logoWidth="181"
              logoHeight="51"
            />
          </li>

          <li className="product-col" aria-hidden="true">
            <DecoCard variant="insight" label="Nova Insight" />
            <DecoCard variant="recon" label="Nova Recon" />
          </li>
        </ul>
      </div>
    </section>
  );
}
